import React from "react";
import { ThemeProvider as MuiThemeProvider } from "@material-ui/core/styles";
import { history } from "store/store";
import { ConnectedRouter } from "connected-react-router";
import { createTheme } from "styles/defaultTheme";
import { Provider } from "react-redux";
import { Store } from "redux";
import { CssBaseline } from "@material-ui/core";
import { ThemeProvider } from "styled-components";
import { BackdropProvider } from "components/BackdropProvider/BackdropProvider";
import { AlertProvider } from "components/AlertProvider/AlertProvider";
import { BrowserRouter, MemoryRouter } from "react-router-dom";
import { QueryCache, ReactQueryCacheProvider } from "react-query";

interface ProviderWrapper {
    store: Store;
}

const queryCache = new QueryCache({
    defaultConfig: {
        queries: {
            refetchOnWindowFocus: false,
        },
    },
});

export const ProviderWrapper: React.FC<ProviderWrapper> = ({ children, store }) => {
    return (
        // <React.StrictMode>
        <Provider store={store}>
            <ReactQueryCacheProvider queryCache={queryCache}>
                <BackdropProvider>
                    <AlertProvider>
                        <CssBaseline />
                        <ConnectedRouter history={history}>
                            <BrowserRouter basename="/xServer/ix">
                                <MuiThemeProvider theme={createTheme()}>
                                    <ThemeProvider theme={createTheme()}>{children}</ThemeProvider>
                                </MuiThemeProvider>
                            </BrowserRouter>
                        </ConnectedRouter>
                    </AlertProvider>
                </BackdropProvider>
            </ReactQueryCacheProvider>
        </Provider>
        // </React.StrictMode>
    );
};

export const StorybookProviderWrapper: React.FC<ProviderWrapper> = ({ children, store }) => (
    // <React.StrictMode>
    <Provider store={store}>
        <BackdropProvider>
            <AlertProvider>
                <CssBaseline />
                <MemoryRouter>
                    <MuiThemeProvider theme={createTheme()}>
                        <ThemeProvider theme={createTheme()}>{children}</ThemeProvider>
                    </MuiThemeProvider>
                </MemoryRouter>
            </AlertProvider>
        </BackdropProvider>
    </Provider>
    // </React.StrictMode>
);
